module.exports = __webpack_public_path__ + "static/media/c-sharp-beginner.f7b488db.png";